export const ACCESS_TOKEN = 'access_token';

export const appId = 'wxf9f97c5aa7fff4fd';

export const defaultTablePageSize = 20;
export const defaultFetchAllPageSize = 1000;
export const defaultPageSizeOptions = ['10', '20', '40', '60', '80', '100'];
export const autoCompletePageSizes = ['10', '20', '50', '100']; // 主要用于搜索的表格
